import { SoapUtils } from "../../../utils/SoapUtils";

export interface Filter {
    COL: FilterCol[];
}

export function toFilterXml(filter: Filter, nodeName:string = 'FILTER'): string {
    var xml = `<${nodeName}>`;
    if(filter.COL) {
        filter.COL.forEach(function (filterCol) {
            xml += toFilterColXml(filterCol);
        });
    }
    xml += `</${nodeName}>`;
    return xml;
}

export interface FilterCol {
    name:        string;
    type:        string;
    value?:       string;
    negation?:    string;
    includeNull?: string;
}
export function toFilterColXml(filterCol: FilterCol): string {
    var xml = `<COL>`;
    xml += SoapUtils.makeNode(filterCol.name, 'name');
    xml += SoapUtils.makeNode(filterCol.type, 'type');
    xml += SoapUtils.makeNode(filterCol.value, 'value');
    xml += SoapUtils.makeNode(filterCol.negation, 'negation');
    xml += SoapUtils.makeNode(filterCol.includeNull, 'includeNull');
    xml += `</COL>`;
    return xml;
}